import { Component, Injector, Input, OnInit } from '@angular/core';
import { AddressService } from 'tnx-admin-service/address/services';
import { AddressControlSchema, ComponentContextService, ContainerSchema, DataFormBase, EventData, FormSchemaBase, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    providers: [ComponentContextService],
})
export class AddressFormComponent extends DataFormBase implements OnInit {
    @Input() level: number;

    statusDataSource = [];

    constructor(
        protected _injector: Injector,
        private _addressService: AddressService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.schema = <FormSchemaBase[]>[
            new AddressControlSchema({
                label: 'Địa chỉ thường trú',
                field: 'address',
                mdWidth: 12,
                required: true,
                requiredStreet: false,
                requiredNo: false,
                showInBox: true
            }),
            new TextControlSchema({
                label: 'Test',
                field: 'test',
                mdWidth: 6,
            }),
            new ContainerSchema({
                controls: [
                    new TextControlSchema({
                        label: 'Test',
                        field: 'test',
                        mdWidth: 6,
                    }),
                    new TextControlSchema({
                        label: 'Test 2',
                        field: 'test2',
                        mdWidth: 6,
                    })
                ],
                showInBox: true,
                label: 'Địa chỉ thường trú',
                field: 'address2',
                mdWidth: 12
            })
        ];
        super.ngOnInit();
    }

    async onFormInitialized(constrols: EventData) {
        // let itemName = 'tỉnh, thành phố';
        // if (this.model.data.level == ENUM_DON_VI_HANH_CHINH.QUAN_HUYEN)
        //     itemName = 'quận huyện';
        // else if (this.model.data.level == ENUM_DON_VI_HANH_CHINH.PHUONG_XA)
        //     itemName = 'phường xã';
        // else if (this.model.data.level == ENUM_DON_VI_HANH_CHINH.DUONG)
        //     itemName = 'đường';
        // if (this.model.data.id) {
        // }
        // else {
        //     this.model.data.hasBuildIn = true;
        //     this.model.data.level = this.level;
        // }
    }

    async onFormEvent(evt) {
        console.log(evt);
    }

    async onAfterGetDetail() {
        // if (this.model.data.level == ENUM_DON_VI_HANH_CHINH.QUAN_HUYEN) {
        //     this.model.data.cityId = this.model.data.parentID;
        // }
        // if (this.model.data.level == ENUM_DON_VI_HANH_CHINH.PHUONG_XA) {
        //     this.model.data.districtId = this.model.data.parentID;
        // }
    }

    async modifyDetailData(data) {
        // if (data.level == ENUM_DON_VI_HANH_CHINH.DUONG) {
        //     data.wardId = data.parentID;
        //     // Lấy id quận huyện
        //     const itemPhuongXa = (await this._addressService.getDetailByFilter([{
        //         field: 'idRoot', operator: Operator.equal, value: data.parentID
        //     }])).data;
        //     data.districtId = itemPhuongXa.parentID;
        //     if (itemPhuongXa == null)
        //         return;
        //     const itemQuanHuyen = (await this._addressService.getDetailByFilter([{
        //         field: 'idRoot', operator: Operator.equal, value: itemPhuongXa.parentID
        //     }])).data;
        //     data.cityId = itemQuanHuyen.parentID
        // }
        // else if (data.level == ENUM_DON_VI_HANH_CHINH.PHUONG_XA) {
        //     data.districtId = data.parentID;
        //     const itemQuanHuyen = (await this._addressService.getDetailByFilter([{
        //         field: 'idRoot', operator: Operator.equal, value: data.parentID
        //     }])).data;
        //     data.cityId = itemQuanHuyen.parentID;
        // }
    }

    onBeforeSave() {
        // if (this.model.data.name)
        //     this.model.data.nameWithoutSpace = this.model.data.name.split(' ').join('');
        // this.model.data.idRoot = this.model.data.code;
        // if (this.model.data.level == ENUM_DON_VI_HANH_CHINH.QUAN_HUYEN) {
        //     this.model.data.parentID = this.model.data.cityId;
        // }
    }
}
